import { render, staticRenderFns } from "./AdminZiad.vue?vue&type=template&id=a4d0e31c"
import script from "./AdminZiad.vue?vue&type=script&lang=js"
export * from "./AdminZiad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports